import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { CircularProgress, Box } from '@mui/material'
import 'leaflet/dist/leaflet.css'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  // StrictMode disabled due to conflicts with Leaflet map initialization
  // StrictMode causes double-mounting in development which breaks Leaflet
  <Suspense
    fallback={
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    }
  >
    <App />
  </Suspense>,
)
